import _ from "lodash";
import axios from "axios";

import IMeta from "models/IMeta";
import { setLoading } from "../app/actions";
import generateQuery from "helpers/query";
import { statementsInvoiceSorting, statementsSorting } from "constants/sorting";
import { CUSTOM_SETTINGS } from "constants/.";

export const actionTypes = {
  GET_ACCOUNT_STATEMENTS_REQUEST: "GET_ACCOUNT_STATEMENTS_REQUEST",
  GET_ACCOUNT_STATEMENTS_SUCCESS: "GET_ACCOUNT_STATEMENTS_SUCCESS",
  GET_ACCOUNT_STATEMENTS_FAILURE: "GET_ACCOUNT_STATEMENTS_FAILURE"
};

export default class Actions {
  public static getAccountStatements(meta: IMeta = {}) {
    return async (dispatch, getState) => {
      dispatch(request());
      dispatch(setLoading(true));

      if (_.isEmpty(meta)) {
        meta = _.get(getState(), "accountStatements.meta", {});
      }

      if (!meta.pageSize) {
        const savedSettings = JSON.parse(
          localStorage.getItem("customSettings") || "{}"
        );
        _.set(
          meta,
          "pageSize",
          _.get(
            savedSettings,
            `${CUSTOM_SETTINGS.accountStatements}.pageSize`,
            10
          )
        );
      }

      const url = `Statements?$select=Id,DocumentId,Number,PaymentDate,Version,DocumentDate,PreviousBalance,EndSaldo,Read
        ${generateQuery(meta, "RelationId")}`;

      try {
        const { data } = await axios.get(url);
        const payload = _.get(data, "value", []);
        const newMeta = {
          ...meta,
          count: +_.get(data, "odata.count", 0)
        };
        dispatch(success(payload, newMeta));
        dispatch(setLoading(false));
      } catch (error) {
        dispatch(failure(error));
        dispatch(setLoading(false));
      }
    };

    function request() {
      return { type: actionTypes.GET_ACCOUNT_STATEMENTS_REQUEST };
    }
    function success(payload, meta) {
      return {
        type: actionTypes.GET_ACCOUNT_STATEMENTS_SUCCESS,
        payload,
        meta
      };
    }
    function failure(error) {
      return { type: actionTypes.GET_ACCOUNT_STATEMENTS_FAILURE, error };
    }
  }

  public static async getExportData(searchString) {
    const urlHeader = `Statements?$expand=Relation,Relation/VATPostingGroup
      &$select=Id,Number,PaymentDate,Version,DocumentDate,PreviousBalance,EndSaldo,
      SaldoMutations,SaldoInvoices,SaldoDeductionsBlockages,Relation/Number,Relation/Name,
      Relation/VATPostingGroup/Description${generateQuery(
        { searchString, findAll: true, defaultSorting: statementsSorting },
        "RelationId"
      )}`;
    const urlInvoices = `StatementLines?$expand=Invoice,Invoice/Order,InvoiceType,Statement
      &$select=Invoice/Number,Invoice/InvoiceDate,Invoice/Order/Number,InvoiceType/Description,
      OriginalAmount,PaidAmount,SaldoStatement,Statement/Id
      ${generateQuery(
        { defaultSorting: statementsInvoiceSorting, findAll: true },
        "Statement/RelationId"
      )} and TypeId eq '0'`;
    const urlDeductions = `StatementLines?$expand=Invoice,OnHold,Statement
      &$select=Invoice/Number,Invoice/InvoiceDate,Invoice/PaymentDate,OriginalAmount,
      PaidAmount,SaldoStatement,OnHold/Description,Statement/Id
      ${generateQuery(
        { defaultSorting: statementsInvoiceSorting, findAll: true },
        "Statement/RelationId"
      )} and (TypeId eq '1' or TypeId eq '2')`;

    try {
      let data = await axios.all([
        axios.get(urlHeader),
        axios.get(urlInvoices),
        axios.get(urlDeductions)
      ]);
      data = _.map(data, "data.value");
      const orderedData = _.map(data[0], item => {
        return {
          header: item,
          invoices: _.filter(data[1], ["Statement.Id", item.Id]),
          deductions: _.filter(data[2], ["Statement.Id", item.Id])
        };
      });
      return orderedData;
    } catch (error) {
      return error.response;
    }
  }
}
